import { useEffect, useState } from "react";

export default function DrawerBackdrop({ page }) {

    const [backdropPlaceholder, setbackdropPlaceholder] = useState(null);

    useEffect(() => {
        if(page === 'elab') {
            setbackdropPlaceholder(
                <>
                <div className="hero-elab-wrapper mb-4">
                    <div>
                        <h1>Elaborazioni 🔥</h1>
                        <div className="hero-elab-phrase">Dai un’occhiata alle ultime elaborazioni caricate dagli utenti:</div>
                    </div>
                    <div className="mt-2 btn-centered-mobile">
                        <a className="btn btn-primary" href="/elaborations/add">➕ Aggiungi nuova elaborazione</a>
                    </div>
                </div>
                <div>
                <div className="card shadow-sm border-0">
                    <div className="image-gallery image-fitted" aria-live="polite">
                        <div className="image-gallery-content bottom">
                            <div className="image-gallery-slide-wrapper bottom">
                            <div className="image-gallery-slides">
                                <div aria-label="Go to Slide 1" tabIndex="-1" className="image-gallery-slide  center " role="button">
                                    <div><img className="image-gallery-image" src="https://res.cloudinary.com/racemood/image/upload/racehome/cltszgs3zy9i9xivz1vk.jpg"/></div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <h5 className="card-title">208 GTi – primo step serio di elaborazione 😍🔥</h5>
                        <p className="card-text">Ciao a tutti! Ho appena concluso la mia elaborazione Stage 2 sulla 208 GTi. Ho montato intake MST, downpipe 200 celle e ovviamente fatto mappa. Sulla carta siamo sui 245cv ma più che altro ho notato quanto l’auto respiri meglio e sia più reattiva. Prossimo step? Forse turbina maggiorata... vediamo</p>
                        <p className="card-text"><small className="text-muted"><b className="d-inline">agrassi · </b>7 lug alle 16:02</small></p>
                        <div className="octane-like like-step"><img className="mr-2" src="/static/media/fuel-tank.cad02c8d.png" width="35px" height="35px" alt="tank" />0 / 100 ottani<label className="btn mb-0 btn-light"><input id="410" type="checkbox" className="like-button"/>+1 <i className="fas fa-tint" aria-hidden="true"></i></label></div>
                        <div className="accordion_content mt-4">
                            <div className="410_accordion_body custom_scroll">
                            <div></div>
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
                </div>
                </>
            );
        } else {
            setbackdropPlaceholder(
                <>
                <div className="hero-disc-wrapper mb-4">
                    <h1>Spazio ai dubbi tecnici! 🧠🔧</h1>
                </div>
                <div>
                    <div className="card shadow-sm">
                        <div className="card-header disc-card-header"><b className="disc-name-color">boosted_mauro</b> chiede</div>
                        <div className="card-body">
                            <h5 className="card-title">Cambio marce duro su 147 GTA</h5>
                            <p className="card-text">Ciao a tutti, scrivo perché sono un po' preoccupato. Ho una 147 GTA con circa 120.000 km, la uso solo nei weekend per divertirmi, però ultimamente ho notato che quando passo dalla seconda alla terza marcia il cambio è molto più duro del solito. Mi sembra quasi che la leva si blocchi per un attimo, soprattutto a freddo. Mi hanno detto che potrebbe essere solo l'olio del cambio vecchio, ma qualcuno mi ha parlato anche di volano o frizione da sostituire. Non so bene come muovermi e vorrei evitare di spendere subito un capitale se non è necessario... Qualcuno ha avuto lo stesso problema?</p>
                            <p className="card-text"><small className="text-muted">9 lug alle 13:33</small></p>
                            <div className="accordion_content">
                                <div className="33_accordion_body custom_scroll">
                                    <div>
                                        <div>
                                            <hr />
                                            <h6>elena_drivers</h6>
                                            Ciao Mauro, anche a me era successo su una vecchia 156. Prima di pensare a frizione o volano, ti consiglio di cambiare subito l'olio del cambio, magari uno di qualità (tipo Motul Gear 300). Se la situazione non migliora, allora vai a controllare il gruppo frizione, ma spesso con un cambio olio si risolve!
                                        </div>
                                        <div>
                                            <hr />
                                            <h6>oldschooler93</h6>
                                            Concordo! Controlla anche i cavi del cambio, soprattutto sulle GTA tendono a indurirsi con il tempo. Io sulla mia li ho sostituiti ed è tornata morbida.
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
                </>
            );
        }
    }, [])

    

    return (
        <>
            <div className="home-content">
                <div id="for-adv" className="row">
                    <div className="col-md-2 d-md-block d-none"></div>
                    <div className="col-md-8">
                        <div className="container">
                            {backdropPlaceholder}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}